module.exports = "<div class=\"four-zero-four\">\n  <div class=\"four-zero-four-container\">\n      <div class=\"error-code\">404</div>\n      <div class=\"error-message\">This page doesn't exist</div>\n      <div class=\"button-place\">\n          <a href=\"../../index.html\" class=\"btn btn-default btn-lg waves-effect\">GO TO HOMEPAGE</a>\n      </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/errors-pages/not-found/not-found.component.html
// module id = ./src/app/errors-pages/not-found/not-found.component.html
// module chunks = main